import React from 'react';

import type {
  SaveList,
  SaveListItem,
} from '../../../../../types/save-types.js';

import { useByfunnPulseContext } from '../../../../../pulse/index.js';
import { itemIsSaved } from '../../../../../views/components/saving/utils.js';
import SaveButton from '../SaveButton.js';

type ListicleNumberProps = {
  handleOverlay: (item: SaveListItem) => void;
  number: number;
  groupItem: SaveListItem;
  savedItems: SaveList[];
  showNumber: boolean;
  title: string;
};

export const formatNumber = (number: number) => {
  return number < 10 ? `0${number}` : `${number}`;
};

const ListicleNumber: React.FC<ListicleNumberProps> = ({
  number,
  handleOverlay,
  groupItem,
  savedItems,
  showNumber,
  title,
}) => {
  const { trackClickUIElement } = useByfunnPulseContext();
  const formattedNumber = formatNumber(number);
  const isSaved = itemIsSaved(groupItem, savedItems);

  const handleOnClick = (item: SaveListItem): void => {
    trackClickUIElement(
      {
        object: {
          id: 'article:save-button',
          name: 'Save listicle item',
          elementType: 'Button',
        },
      },
      {
        object: {
          objectId: 'save-button',
          name: 'Save listicle item',
          elementType: 'Button',
        },
        placement: { containerName: 'page' },
      },
    );

    handleOverlay(item);
  };

  return (
    <div className="heading listicle-number">
      {number >= 0 && showNumber ? (
        <span key="lead" className="item-number" id={formattedNumber}>
          {formattedNumber}
        </span> // if listicle-item add item-number
      ) : (
        <p className="subheading">{title}</p>
      )}
      <SaveButton
        handleOnClick={handleOnClick}
        item={groupItem}
        isSaved={isSaved}
      />
    </div>
  );
};

export default ListicleNumber;
